import { useGlobalData } from '../providers/globalDataProvider/globalDataProvider.useGlobalData';

const windowGlobal = typeof window !== 'undefined' && window;

export const useDataLayer = () => {
  const { language, country } = useGlobalData();
  const registerEvent = ({ event, params = {} }) => {
    const isEmpty = !event || (event && event.length === 0);
    if (!isEmpty && windowGlobal && window.dataLayer) {
      window.dataLayer.push({
        event,
        language,
        country,
        ...params,
      });
    }
  };
  return registerEvent;
};

export default useDataLayer;
